import { render, staticRenderFns } from "./CardContratoAssociados.vue?vue&type=template&id=5a6fb7ec&lang=pug"
import script from "./CardContratoAssociados.vue?vue&type=script&lang=js"
export * from "./CardContratoAssociados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports